import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export interface Industry {
  id: string;
  name: string;
  emoji: string;
}

interface IndustrySelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const industries: Industry[] = [
  { id: 'advertising-marketing', name: 'Advertising & Marketing', emoji: '📢' },
  { id: 'aerospace-defense', name: 'Aerospace & Defense', emoji: '🚀' },
  { id: 'agriculture', name: 'Agriculture', emoji: '🌾' },
  { id: 'automotive', name: 'Automotive', emoji: '🚗' },
  { id: 'banking-financial', name: 'Banking & Financial Services', emoji: '🏦' },
  { id: 'blockchain-web3', name: 'Blockchain & Web3', emoji: '⛓️' },
  { id: 'construction', name: 'Construction', emoji: '🏗️' },
  { id: 'consumer-goods', name: 'Consumer Goods', emoji: '🛍️' },
  { id: 'ecommerce', name: 'E-commerce', emoji: '🛒' },
  { id: 'education', name: 'Education', emoji: '📚' },
  { id: 'energy-utilities', name: 'Energy & Utilities', emoji: '⚡' },
  { id: 'entertainment-media', name: 'Entertainment & Media', emoji: '🎬' },
  { id: 'fashion-apparel', name: 'Fashion & Apparel', emoji: '👕' },
  { id: 'food-beverage', name: 'Food & Beverage', emoji: '🍽️' },
  { id: 'gaming', name: 'Gaming', emoji: '🎮' },
  { id: 'government', name: 'Government', emoji: '🏛️' },
  { id: 'healthcare', name: 'Healthcare', emoji: '⚕️' },
  { id: 'hospitality-tourism', name: 'Hospitality & Tourism', emoji: '🏨' },
  { id: 'information-technology', name: 'Information Technology', emoji: '💻' },
  { id: 'insurance', name: 'Insurance', emoji: '🛡️' },
  { id: 'legal-services', name: 'Legal Services', emoji: '⚖️' },
  { id: 'manufacturing', name: 'Manufacturing', emoji: '🏭' },
  { id: 'non-profit', name: 'Non-Profit', emoji: '🤝' },
  { id: 'pharmaceuticals', name: 'Pharmaceuticals', emoji: '💊' },
  { id: 'real-estate', name: 'Real Estate', emoji: '🏢' },
  { id: 'retail', name: 'Retail', emoji: '🏪' },
  { id: 'saas', name: 'SaaS (Software as a Service)', emoji: '💻' },
  { id: 'sports', name: 'Sports', emoji: '⚽' },
  { id: 'telecommunications', name: 'Telecommunications', emoji: '📡' },
  { id: 'transportation-logistics', name: 'Transportation & Logistics', emoji: '🚢' }
];

export const IndustrySelect: React.FC<IndustrySelectProps> = ({
  value,
  onChange,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedIndustry = industries.find(industry => industry.id === value) || industries[0];

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex items-center justify-between px-3 py-2 border border-gray-300 rounded-lg bg-white text-left ${className}`}
      >
        <span className="flex items-center gap-2">
          <span className="text-lg">{selectedIndustry.emoji}</span>
          <span className="text-gray-700">{selectedIndustry.name}</span>
        </span>
        <ChevronDown className="w-4 h-4 text-gray-500" />
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute left-0 right-0 mt-2 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-20 max-h-[300px] overflow-y-auto">
            <div className="py-1">
              {industries.map(industry => (
                <button
                  key={industry.id}
                  onClick={() => {
                    onChange(industry.id);
                    setIsOpen(false);
                  }}
                  className={`w-full text-left px-4 py-2 flex items-center gap-2 ${
                    industry.id === value
                      ? 'bg-primary-50 text-primary-600'
                      : 'text-gray-700 hover:text-primary-600'
                  }`}
                >
                  <span className="text-lg">{industry.emoji}</span>
                  <span className="font-medium">{industry.name}</span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};